/** @jsx jsx */
import { jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Grid, Typography2 } from '@coursera/cds-core';
import { CurriculumIcon } from '@coursera/cds-icons';

import { Button, Spacer } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-home';

type Props = {
  searchQuery: string;
  numResults: number;
  clearSearch: () => void;
};

export default function ProgramSearchStatus({ searchQuery, clearSearch, numResults }: Props) {
  return (
    <div>
      <Grid container alignItems="center" spacing={32}>
        <Grid item>
          <Typography2 component="p">
            {_t('You searched for ')}
            <strong>{searchQuery}</strong>
            <FormattedMessage
              message={_t('. {numResults} {numResults, plural, =1 {match.} other {matches.}}')}
              numResults={numResults || '0'}
            />
          </Typography2>
        </Grid>
        <Grid item>
          <Button variant="ghost" onClick={clearSearch}>
            {_t('Clear search')}
          </Button>
        </Grid>
      </Grid>
      <Spacer size={32} />
      {numResults === 0 && (
        <Grid container direction="column" spacing={32} alignItems="center">
          <Grid
            item
            container
            alignItems="center"
            justifyContent="center"
            css={{
              width: '10.1rem',
              height: '10.1rem',
              borderRadius: '50%',
              background: 'var(--cds-color-grey-50)',
            }}
          >
            <CurriculumIcon size="large" css={{ transform: 'scale(2)' }} />
          </Grid>
          <Grid item>
            <Typography2 component="p">{_t("We couldn't find any programs that matched your search.")}</Typography2>
          </Grid>
        </Grid>
      )}
    </div>
  );
}
